<!-- /* PAT-203 — pre-maintenance announcement card + countdown bar. */ -->
@if (!dismissed() && announcement()) {
  <div class="announce-card" role="alertdialog" aria-label="Maintenance Notification">
    <div class="announce-card__header">
      <i class="fa-solid fa-triangle-exclamation announce-icon" aria-hidden="true"></i>
      <span class="announce-card__title">Maintenance Notification</span>
      <button type="button" class="announce-card__close" aria-label="Dismiss" (click)="dismiss()">
        <i class="fa-solid fa-xmark" aria-hidden="true"></i>
      </button>
    </div>

    <p class="announce-card__message">{{ announcement()?.message }}</p>

    @if (countdownDisplay(); as cd) {
      <div class="announce-card__countdown">
        <span class="countdown-label">Starts in</span>
        <span class="countdown-value" [class.countdown-value--now]="secondsLeft() === 0">{{ cd }}</span>
      </div>
    }

    <div class="announce-card__actions">
      <button type="button" class="pathways-btn-primary" (click)="dismiss()">Got it</button>
    </div>
  </div>
}

@if (dismissed() && secondsLeft() !== null) {
  <div class="maintenance-countdown-bar" role="status" aria-live="polite">
    <i class="fa-solid fa-triangle-exclamation bar-icon" aria-hidden="true"></i>
    @if (secondsLeft() === 0) {
      <span class="bar-message--urgent">Maintenance is starting — please save your work!</span>
    } @else {
      <span class="bar-label">Maintenance starts in</span>
      <span class="bar-timer">{{ countdownDisplay() }}</span>
    }
  </div>
}
